import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useResponsiveStyles } from "../../../styles/useResponsiveStyles";

export const MultiSelectHeader = ({
    isOpen,
    selectedOptions,
    totalCount,
    onToggle,
    itemText,
    tierOptions,
}) => {
    // Check if any tierOption has a count
    const selectedCount = selectedOptions.length;
    const hasCount = tierOptions.some((option) => option.count);
    const { getSectionStyle, getContainerHeight, getFontSize } =
        useResponsiveStyles();

    return (
        <Box
            onClick={onToggle}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",

                pl: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
                cursor: "pointer",
                "&:hover": {
                    borderColor: "#ef4444",
                },
                ...getContainerHeight("filter-height"),
                ...getSectionStyle("report"),
            }}
        >
            <Typography
                sx={{
                    ...getFontSize("body1"),
                    color:
                        selectedCount > 0 ? "text.primary" : "text.secondary",
                }}
            >
                {selectedCount === 0 && `Select ${itemText}`}
                {selectedCount > 0 &&
                    selectedCount < totalCount &&
                    (hasCount ? (
                        <>
                            <span>
                                {selectedCount} {itemText}
                                {selectedCount !== 1 ? "s" : ""} selected{" "}
                            </span>
                            <span style={{ color: "#ED1C24" }}>
                                (
                                {selectedOptions.reduce(
                                    (acc, option) => acc + (option.count || 0),
                                    0
                                )}
                                )
                            </span>
                        </>
                    ) : (
                        `${selectedCount} ${itemText}${
                            selectedCount !== 1 ? "s" : ""
                        } selected`
                    ))}
                {selectedCount === totalCount &&
                    totalCount > 0 &&
                    (hasCount ? (
                        <>
                            <span>All {itemText}s selected </span>
                            <span style={{ color: "#ED1C24" }}>
                                (
                                {selectedOptions.reduce(
                                    (acc, option) => acc + (option.count || 0),
                                    0
                                )}
                                )
                            </span>
                        </>
                    ) : (
                        `All ${itemText}s selected`
                    ))}
            </Typography>
            <IconButton size="small" sx={{ color: "action.active" }}>
                {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </IconButton>
        </Box>
    );
};
